import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TimeFormatDirective } from './modules/time-format.directive';
import { NgToastModule } from 'ng-angular-popup';
import { NotificationService } from './core/notification/notification.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'environments/environment';

//import { RaterComponent } from './modules/rater/rater.component';
//import { ActivateComponent } from './modules/authentication/activate/activate.component';

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled'
};

@NgModule({
    declarations: [
        AppComponent,
        TimeFormatDirective
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),
        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),
        // Core module of your application
        CoreModule,
        // Layout module of your application
        LayoutModule,
        // Material
        MatCardModule,
        MatButtonModule,
        NgToastModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            //enabled: !isDevMode(),
            enabled: (environment as any).enableServiceWorker ? (environment as any).enableServiceWorker : false,
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })
    ],
    providers: [NotificationService],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}
